import React, { type ComponentType } from 'react';
import type { BlueprintModuleKey } from '../../../../../model';
import { Container } from './styled';

export type Props = {
	blueprintModuleKeys: BlueprintModuleKey[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	BlueprintOptionComponent: ComponentType<any>;
};

export default function BlueprintList(props: Props) {
	const { BlueprintOptionComponent, blueprintModuleKeys } = props;
	return (
		<Container>
			{blueprintModuleKeys.map((blueprintModuleKey) => (
				<BlueprintOptionComponent
					key={blueprintModuleKey}
					blueprintModuleKey={blueprintModuleKey}
				/>
			))}
		</Container>
	);
}
